import { FETCH_WIDGETS_FAILURE } from '../../types'

export default function createFetchWidgetsFailAction(error) {
  return { type: FETCH_WIDGETS_FAILURE, payload: { payload: error } }
}
